import { render, staticRenderFns } from "./Calidad.vue?vue&type=template&id=14c2cdc4&"
import script from "./Calidad.vue?vue&type=script&lang=js&"
export * from "./Calidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports